import { Component, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NavController, NavParams, PopoverController, Refresher } from 'ionic-angular';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

import { PromoProductHistory } from '../../interfaces/PromoProduct.interface';
import { PromoProductsService } from '../../providers/promo-products/promo-products.service';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';
import { PromoInfoPage } from '../promo-info/promo-info';
import { PromoProductItem } from '../../interfaces/PromoItem.interface';

@Component({
  selector: 'page-profile-promo-product',
  templateUrl: 'profile-promo-product.html',
  providers: [PromoProductsService]
})
export class ProfilePromoProductPage {
  public browserType: string = '';
  private subscription$: Subscription;
  @ViewChild(Refresher) refresher: Refresher;
  public product: PromoProductHistory = null;
  public promoItems: PromoProductItem[] = [];
  private userId: string = null;
  public pointsLimit: number = 0;

  public loadingMore: boolean = false;
  public loading: boolean = false;

  public currentPage: number = null;
  public nextPage: number = null;
  public lastPage: number = null;
  public tickets: number[] = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private promoProductsService: PromoProductsService,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private popoverCtrl: PopoverController
  ) {
    this.userId = localStorage.getItem('tuid');
    this.product = navParams.get('product');
  }
  ionViewCanEnter(): void {
    this.loading = true;
    this.browserType = this.checkBrowser();
  }
  ionViewDidEnter() {
    this.loading = true;
    this.subscription$ = this.promoProductsService.getPromoProductHistory(this.userId, this.product.teamId)
      .subscribe((response: PromoProductItem[]) => {
        this.promoItems = this.sortByDate(response)
        this.calculateLimit(response);
        this.loading = false;
      },
        ((error: HttpErrorResponse) => {
          this.loading = false;
          this.apiErrorHandler.handleError({ error })
        }))
  }

  public pullToRefresh(event): void {
    this.subscription$ = this.promoProductsService.getPromoProductHistory(this.userId, this.product.teamId)
      .subscribe((response: PromoProductItem[]) => {
        this.promoItems = this.sortByDate(response)
        this.calculateLimit(response);
        this.refresher.complete();
      }, ((error: HttpErrorResponse) => {
        this.refresher.complete();
        this.apiErrorHandler.handleError({ error })
      }))
  }
  public spentOrEarned(limit_delta: number): string {
    return limit_delta >= 0 ?
      `You earned ${limit_delta} point(s)` : `You spent ${limit_delta * -1} point(s)`;
  }
  public pointsClass(promoPoint: PromoProductItem): string {
    if (promoPoint.limit_delta >= 0) return 'bg-teal';
    return 'bg-brand-blue'
  }

  public pointsDate(promoPoint: PromoProductItem): string {
    if (promoPoint.created_at) return moment(promoPoint.created_at).format('Do MMM YYYY');
    return moment(promoPoint.updated_at).format('Do MMM YYYY');
  }
  private calculateLimit(promoProducts: PromoProductItem[]): void {
    let limit = 0;
    promoProducts.forEach((promoProduct: PromoProductItem) => limit = limit + promoProduct.limit_delta);
    this.pointsLimit = limit;
    this.tickets = Array(this.pointsLimit).fill(1);
    this.tickets.length > 9 ? this.tickets = this.tickets.slice(0, 9) : null;
  }
  public infoPopover(): void {
    let checkinPopover = this.popoverCtrl.create(PromoInfoPage,
      {},
      {
        cssClass: 'complete-booking-modal',
        enableBackdropDismiss: false
      });

    checkinPopover.present();
    checkinPopover.onDidDismiss(() => { })
  }
  private sortByDate(promoProducts: PromoProductItem[]): PromoProductItem[] {
    return promoProducts.sort((a, b) => (b.updated_at > a.updated_at) ? 1 : (b.updated_at < a.updated_at) ? -1 : 0);
  }
  checkBrowser() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return `IE ${tem[1] || ''}`;
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR|Edge\/(\d+)/)
      if (tem != null) { return `Opera ${tem[1]}`; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return `${M[0]} ${M [1]}`
  }
  ionViewDidLeave(): void {
    this.subscription$.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/pages/profile-promo-product/profile-promo-product.ts